import { IShader, ShaderBase } from '../shader';
import { PBRMetallicRoughnessMaterial, Color3, Texture, Scene } from '@babylonjs/core';
import { stringUtil } from '@/models/stringUtil';

export class ShaderNSlizgacz extends ShaderBase implements IShader {

    public diffuse: string = 'diffuse/c_black.jpg';
    public normal: string = 'diffuse/solid_normal.png';
    public avatar: string = '200110_CREATIVE_00000.png';
    public text: string = 'sliderLegs';

    public get key(): string { return 'ShaderNSlizgacz'; }

    public getMaterial(scene: Scene, light: string = ''): PBRMetallicRoughnessMaterial {
        const material = new PBRMetallicRoughnessMaterial('material', scene);
        material.baseColor = new Color3(0.88, 0.88, 0.88);
        material.metallic = 0.1;
        material.roughness = 0.4;

        if (this.diffuse) {
            const url = stringUtil.createDownloadUrl(this.diffuse);
            const baseTexture = new Texture(url, scene);
            baseTexture.coordinatesIndex = 0;
            baseTexture.uScale = 1.54;
            baseTexture.vScale = 1.54;
            material.baseTexture = baseTexture;
        }

        if (this.normal) {
            const url = stringUtil.createDownloadUrl(this.normal);
            const normalTexture = new Texture(url, scene);
            normalTexture.uScale = 1.54;
            normalTexture.vScale = 1.54;
            material.normalTexture = normalTexture;
        }

        if (light) {
            const url = stringUtil.createDownloadUrl(light);
            const lightmapTexture = new Texture(url, scene);
            lightmapTexture.coordinatesIndex = 1;
            lightmapTexture.vScale = -1;
            material.useLightmapAsShadowmap = true;
            material.lightmapTexture = lightmapTexture;
        }

        material.backFaceCulling = false;
        return material;
    }
}
